import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/camera.svg';

export const IconCamera = createIconComponent(Icon);
